const calculateStrength = pass => {
	const checks = [
		// alphaLower
		{
			re: /[a-z]/,
			score: 1
		},
		// alphaUpper
		{
			re: /[A-Z]/,
			score: 5
		},
		// mixture of upper and lowercase
		{
			re: /([a-z].*[A-Z])|([A-Z].*[a-z])/,
			score: 5
		},
		// two numbers
		{
			re: /(.*[0-9].*[0-9])/,
			score: 7
		},
		// special chars
		{
			re: /.[!@#$%^&*?_~]/,
			score: 6
		},
		// multiple special chars
		{
			re: /(.*[!@#$%^&*?_~].*[!@#$%^&*?_~])/,
			score: 7
		},
		// all together now, does it look nice?
		{
			re: /([a-zA-Z0-9].*[!@#$%^&*?_~])|([!@#$%^&*?_~].*[a-zA-Z0-9])/,
			score: 3
		},
		// password of a single char sucks
		{
			re: /(.)\1+$/,
			score: 2
		}
	];

	let score = 0;
	let minChar = 8;
	let len = pass.length;
	let diff = len - minChar;

	if (diff < 0) {
		score -= 100;
	} else if (diff >= 5) {
		score += 18;
	} else if (diff >= 3) {
		score += 12;
	} else if (diff === 2) {
		score += 6;
	}

	checks.forEach(check => {
		if (pass.match(check.re)) {
			score += check.score;
		}
	});

	if (score) {
		score += len;
	}

	let strength = 0;

	if (score < 0) {
		strength = 0;
	} else if (score >= 0 && score < 8) {
		strength = 1;
	} else if (score >= 8 && score < 20) {
		strength = 2;
	} else if (score >= 20 && score < 40) {
		strength = 3;
	} else {
		strength = 4;
	}

	return strength;
};

export default calculateStrength;
